import { createRouter, createWebHistory } from 'vue-router'
import HomeView from '../views/HomeView.vue'
import AboutUsView from '../views/AboutUsView.vue'
import ComputerScienceView from '../views/ComputerScienceView.vue'
import TeachingView from '../views/TeachingView.vue'
import CoursesView from '../views/CoursesView.vue'
import TestimonialsView from '../views/TestimonialsView.vue'
import ComputationalThinkingView from '../views/ComputationalThinkingView.vue'
import SafeguardingPrivacyPoliciesView from '../views/SafeguardingPrivacyPoliciesView.vue'

import SchoolPartnershipsView from '../views/SchoolPartnershipsView.vue'

import ArtificialIntelligenceView from '../views/ArtificialIntelligenceView.vue'
import ExamBoardsView from '../views/ExamBoardsView.vue'
import ContactView from '../views/ContactView.vue'
import BlogView from '../views/BlogView.vue'
import BusinessModelView from '../views/BusinessModelView.vue'
import LearnLinuxView from '../views/LinuxView.vue'

const routes = [
  { path: '/', component: HomeView },
{ path: '/about-us', component: AboutUsView },
  { path: '/computer-science', component: ComputerScienceView},
  { path: '/computational-thinking', component: ComputationalThinkingView},
  { path: '/artificial-intelligence', component: ArtificialIntelligenceView},
  { path: '/exam-boards', component: ExamBoardsView },
  { path: '/teaching', component: TeachingView },
  { path: '/courses', component: CoursesView },
  { path: '/testimonials', component: TestimonialsView },
  { path: '/contact', component: ContactView },
  { path: '/blog', component: BlogView },
  { path: '/azb-business-model', component: BusinessModelView },
  { path: '/learn-linux', component: LearnLinuxView },
   { path: '/school-partnerships', component: SchoolPartnershipsView },
  { path: '/policies', component: SafeguardingPrivacyPoliciesView },
]

const router = createRouter({
  history: createWebHistory(),
  routes,
  scrollBehavior() {
    return { top: 0 }; // Always scroll to top when navigating
  }
});


export default router
